import { useCallback, useImperativeHandle, useMemo, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import { CommonService } from 'dashboard-services/services';
import { DropdownService } from 'primary-components';

import getApiConfig from 'api/ApiConfig';
import properties from 'resources/constants/properties.json';

import FilterBody from '../FilterBody';

import { useQueryClient } from '@tanstack/react-query';

const getFilteredSymbolObj = symbol => {
  const filterSymbolObj = {}
  Object.entries(symbol).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      filterSymbolObj[key] = value === "*" ? [] : (typeof value === "string" ? [value] : value)
    }
  })
  return filterSymbolObj;
}

const EMPTY_OBJ = {};
const EMPTY_ARRAY = [];
const SymbolFilter = ({ value, ref, ...props }) => {
  const dispatch = useDispatch(),
        valueParsed = useMemo(() => CommonService.isJson(value) ? JSON.parse(value) : value, [value]),
        { groupName, symbol = {}, metadata = {} } = valueParsed || EMPTY_OBJ,
        getApiConfigLocal = useCallback(() => dispatch(getApiConfig()), [dispatch]),
        queryClient = useQueryClient(),
        filterSymbolObj = useMemo(() => getFilteredSymbolObj(symbol), [symbol]),
        filterMetadataObj = useMemo(() => getFilteredSymbolObj(metadata), [metadata]),
        [symbolKeyQuery, setSymbolKeyQuery] = useState(),
        { fetchNextPage: fetchMoreKeys, isFetching: isFetchingKeys, isFetchingNextPage: isFetchingNextPageKeys, data: symbolKeysFromApiRaw = EMPTY_ARRAY } = DropdownService.useQuerySymbolKeys({
          queryClient,
          input: symbolKeyQuery,
          groupName,
          useEs: properties.useEsSymbolListing === "true",
          symbols: filterSymbolObj,
          metadata: true,
          metadatas: filterMetadataObj,
          getApiConfig: getApiConfigLocal,
          size: 20,
          enabled: !!groupName,
        }),
        groupRef = useRef()

  useImperativeHandle(ref, () => ({ 
    validateForForm: () => groupRef.current.validateForForm() && valueParsed && valueParsed.groupName && (valueParsed.symbol || valueParsed.metadata),
    isValid: () => groupRef.current.isValid() && valueParsed && valueParsed.groupName && (valueParsed.symbol || valueParsed.metadata)
  }))

  return (
    <FilterBody
        {...props}
        fetchMoreKeys={fetchMoreKeys}
        filterMetadataObj={filterMetadataObj}
        filterSymbolObj={filterSymbolObj}
        groupName={groupName}
        groupRef={groupRef}
        isFetchingKeys={isFetchingKeys}
        isFetchingNextPageKeys={isFetchingNextPageKeys}
        keysFromApiRaw={symbolKeysFromApiRaw}
        metadata={metadata}
        setKeyQuery={setSymbolKeyQuery}
        symbol={symbol}
    />
  )
}

SymbolFilter.displayName = "SymbolFilter"

SymbolFilter.propTypes = {
  value: PropTypes.any.isRequired,
}

export default SymbolFilter;